<script setup>
import { onMounted } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAdmin } from 'dashboard/composables/useAdmin';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const store = useStore();
const { isAdmin } = useAdmin();

onMounted(() => {
  // Listing the account's campaigns is an administrator's. An agent reaches this view only for a
  // voice campaign, which loads the ones they may enter by itself.
  if (!isAdmin.value) return;

  store.dispatch('campaigns/get');
  store.dispatch('labels/get');
});
</script>

<template>
  <div
    class="flex flex-col justify-between flex-1 h-full m-0 overflow-auto bg-n-surface-1"
  >
    <!-- A voice campaign's page is never cached, and mounts again for each campaign. It polls and
         loads the campaign it shows when it mounts: kept alive, it went on polling after the agent
         left it, and showed the first campaign it had loaded on every other one. A new WhatsApp
         campaign is not cached either, or the next one would open with the last one's answers. -->
    <router-view v-slot="{ Component, route }">
      <keep-alive
        v-if="keepAlive"
        :exclude="['VoiceCampaignDetailPage', 'WhatsAppCampaignNewPage']"
      >
        <component :is="Component" :key="route.params.campaignId" />
      </keep-alive>
      <component :is="Component" v-else :key="route.params.campaignId" />
    </router-view>
  </div>
</template>
